import { SVGProps } from "react";

const ArrowDownCircleIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.481.114A10.1 10.1 0 0 1 10.001 0c5.514 0 10 4.486 10 10s-4.487 10-10 10C4.486 20 0 15.514 0 10a9.939 9.939 0 0 1 3.901-7.927.728.728 0 0 1 .888 1.153A8.486 8.486 0 0 0 1.454 10c0 4.712 3.833 8.546 8.546 8.546 4.713 0 8.546-3.834 8.546-8.546S14.713 1.454 10 1.454a8.62 8.62 0 0 0-1.3.098.728.728 0 0 1-.22-1.438ZM10 12.794a.748.748 0 0 1-.531-.22L5.998 9.086A.75.75 0 1 1 7.06 8.028L10 10.981l2.94-2.953a.75.75 0 1 1 1.063 1.06l-3.472 3.485a.744.744 0 0 1-.531.221Z"
      fill="#21245C"
    />
  </svg>
);

export default ArrowDownCircleIcon;
